import {
  CREATE_SERVICE,
  CREATE_SERVICE_SUCCESS,
  DELETE_SERVICE,
  DELETE_SERVICE_SUCCESS,
  GET_SERVICE,
  GET_SERVICE_SUCCESS,
  GET_SERVICES,
  GET_SERVICES_SUCCESS,
  UPDATE_SERVICE,
  UPDATE_SERVICE_SUCCESS,
  UPDATE_SERVICES_PAGINATION,
} from '../constants/Services';

const initialState = {
  services: [],
  service: {
    id: null,
    name: '',
    hours: 0,
    rate: {
      name: '',
      rate: 0,
    },
    parts: [],
  },
  search: '',
  perPage: 10,
  from: 0,
  to: 0,
  page: 1,
  loading: false,
};

const services = (state = initialState, action) => {
  switch (action.type) {
    case GET_SERVICES:
      return {
        ...state,
        search: action.search,
        perPage: action.perPage,
        page: action.page,
        loading: true,
      };
    case GET_SERVICES_SUCCESS:
      return {
        ...state,
        services: action.services,
        total: action.total,
        from: action.from,
        to: action.to,
        loading: false,
      };
    case CREATE_SERVICE:
      return {
        ...state,
        loading: true,
      };
    case CREATE_SERVICE_SUCCESS:
      return {
        ...state,
        service: action.service,
        loading: false,
      };
    case GET_SERVICE:
      return {
        ...state,
        loading: true,
      };
    case GET_SERVICE_SUCCESS:
      return {
        ...state,
        service: action.service,
        loading: false,
      };
    case UPDATE_SERVICE:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_SERVICE_SUCCESS:
      return {
        ...state,
        service: action.service,
        loading: false,
      };
    case DELETE_SERVICE:
      return {
        ...state,
        loading: true,
      };
    case DELETE_SERVICE_SUCCESS:
      return {
        ...state,
        service: initialState.service,
        services: state.services.filter((s) => s.id !== action.service_id),
        loading: false,
      };
    case UPDATE_SERVICES_PAGINATION:
      return {
        ...state,
        search: action.search,
        perPage: action.perPage,
        page: action.page,
      };
    default:
      return state;
  }
};

export default services;
